import { RedirectError } from 'logard';
import { reactive } from 'vue';
import ChatService from '../chat/services/ChatService';
import { BOOKING_OVERVIEW_ROUTE } from '../general/router/constants';
import AuthService from '../general/services/AuthService';
import { validateChatType } from '../general/utils/chatHelpers';
import CommonFilterType from '../shared/constants/CommonFilterType';
import { ContextLoader } from '../shared/models/AbstractContext';
import FilterService from '../shared/services/FilterService';
import { saneNumericId } from '../shared/utils/sanitizers';
import { isPresent, present } from '../shared/utils/typescript';
import { BookingId } from './models/Booking';
import BookingFilters from './models/BookingFilters';
import BookingOverviewContext from './models/BookingOverviewContext';
import BookingService from './services/BookingService';

export const bookingOverviewLoader = new ContextLoader(async s => {
  const filterTypes = present(s.getAttribute<Array<CommonFilterType>>('commonFilters'));
  const filters = new BookingFilters(await FilterService.getFilters(s, filterTypes));
  const context = reactive(await BookingService.loadOverview(filters.common)) as BookingOverviewContext;
  await BookingService.bindBookingBoardUpdateHandlers(context);
  return context;
});

export const bookingDetailLoader = new ContextLoader(async s => {
  const id = s.getPathParam('bookingId', saneNumericId<BookingId>);
  if (!isPresent(id)) throw new RedirectError({ name: BOOKING_OVERVIEW_ROUTE });
  return BookingService.loadCurrent(id);
});

export const chatLoader = new ContextLoader(async s => {
  const chatType = validateChatType(s.getQueryParam('chat'));
  const context = await bookingDetailLoader.getResult(s);
  if (!context.booking.dossier) return null;
  return ChatService.loadForBooking(context.booking, chatType, AuthService.getCurrentUser());
});